import { atom } from "jotai";

export const visibleRowsAtom = atom<string[]>([]);
